// ── Errorzen Contracts — structural type guards ───────────────────────────────
// Structural (never `instanceof`) — instanceof is brittle across separately
// bundled MFE copies of this package. Spec: API Specs: errorzen v2.1 §TS API
// (FR-005, Epic ASC-6291).

import { KnownErrorCodeSchema, type KnownErrorCode } from './codes'
import { ProblemDetailsWireSchema, type ProblemDetails } from './schemas'

/** OPEN — true for any valid wire object, including codes this bundle has never seen. */
export function isProblemDetails(v: unknown): v is ProblemDetails {
  return ProblemDetailsWireSchema.safeParse(v).success
}

/** CLOSED — true only for codes in the generated registry; drives localized copy. */
export function isKnownErrorCode(code: string): code is KnownErrorCode {
  return KnownErrorCodeSchema.safeParse(code).success
}

/**
 * Structural retryability check — reads `.retryable` and nothing else, so it
 * works on a ProblemDetails, an ApiError, or an ErrorPresentation alike.
 * Returns false for null and undefined.
 */
export function isRetryable(v: { retryable?: boolean | null } | null | undefined): boolean {
  return v?.retryable === true
}
